import { useDebug } from './hooks';
import type { ReactNode } from 'react';
import { humanNumber } from '../../helpers';

export const Debug = ({ children, position = 'right', alwaysShow = false, absolute }: { children: ReactNode; position?: 'right' | 'left'; alwaysShow?: boolean; absolute?: boolean }) => {
  const { isEnabled, isDebug } = useDebug();

  if (!alwaysShow && !isDebug && !isEnabled) {
    return null;
  }

  return (
    <div
      className="debug_component"
      style={{
        pointerEvents: 'none',
        opacity: 0.5,
        display: 'inline-block',
        fontSize: 'var(--text-sm)',
        lineHeight: '1em',
        padding: '4px',
        backgroundColor: 'var(--black, #111111)',
        position: absolute ? 'absolute' : 'initial',
        right: position === 'right' ? 0 : undefined,
        left: position === 'left' ? 0 : undefined,
      }}
    >
      {Number(children) ? humanNumber(children as number, 5) : children}
    </div>
  )
};
